
import {
    FETCH_BUYERS_SUCCESS,
    SHOW_BUYER_SUCCESS,
    APPROVE_BUYER_SUCCESS,
    REJECT_BUYER_SUCCESS,
    UPDATE_BUYER_SUCCESS,
    CREATE_BUYER_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    buyers: null,
    buyer: null,
    pagination: null
  };
  
  export default function buyerReducer (state=INITIAL_STATE, action) {

    switch (action.type) {
      case FETCH_BUYERS_SUCCESS:
        return { ...state, buyers: action.payload.buyers, pagination: action.payload.pagination };
      case SHOW_BUYER_SUCCESS:
        return { ...state, buyer: action.payload.buyer };
      case APPROVE_BUYER_SUCCESS:
        return { ...state, buyer: action.payload.buyer };
      case REJECT_BUYER_SUCCESS:
        return { ...state, buyer: action.payload.buyer };
      case UPDATE_BUYER_SUCCESS:
        return { ...state, buyer: action.payload.buyer };
      case CREATE_BUYER_SUCCESS:
        return { ...state, buyer: action.payload.buyer };
      default:
        return state;
    }
  };